import { render, staticRenderFns } from "./IconCopy.vue?vue&type=template&id=bf3718e8"
import script from "./IconCopy.vue?vue&type=script&lang=js"
export * from "./IconCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports